export const specials = [
  {
    id: "s1",
    title: "华语科幻新势力",
    subtitle: "当东方叙事遇见浩瀚宇宙",
    tag: "科幻专题",
    intro:
      "从深空漂流到未来学院，华语科幻正在用独有的温度讲述星辰大海。本专题精选近年最具想象力与情感浓度的华语科幻作品，带你一起仰望星空。",
    reason:
      "科幻不只是特效的狂欢，更是一次关于选择与归途的思考。这三部作品用扎实的设定与真挚的情感，重新定义了我们对星辰的想象。",
    cover:
      "https://readdy.ai/api/search-image?query=atmospheric%20science%20fiction%20collection%20banner%20of%20a%20vast%20starry%20night%20sky%20over%20a%20silhouetted%20futuristic%20city%20with%20a%20giant%20planet%20rising%20deep%20navy%20and%20teal%20tones%20with%20orange%20accent%20glow%20epic%20cinematic%20wide%20composition%20no%20text&width=1280&height=720&seq=special-s1&orientation=landscape",
    mediaIds: ["mv1", "mv8", "tv11"],
  },
  {
    id: "s2",
    title: "悬疑烧脑精选",
    subtitle: "每一帧都是伏笔",
    tag: "悬疑专题",
    intro:
      "喜欢在被线索牵着走的感觉吗？本专题网罗迷雾重重的推理故事，从雨夜追凶到深海信号，让你在层层反转中不断推翻自己的判断。",
    reason:
      "好的悬疑从不靠惊吓，而是靠逻辑与氛围一步一步把你拉入谜题深处。这里的每一部都值得你暂停、倒回、反复推敲。",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20suspense%20collection%20banner%20of%20a%20foggy%20empty%20street%20at%20night%20lit%20by%20a%20single%20cold%20lamp%20with%20deep%20shadows%20and%20mysterious%20depth%20moody%20navy%20and%20steel%20tones%20with%20faint%20amber%20accents%20cinematic%20wide%20composition%20no%20text&width=1280&height=720&seq=special-s2&orientation=landscape",
    mediaIds: ["mv2", "mv5", "tv12", "tv14"],
  },
  {
    id: "s3",
    title: "治愈系家庭片单",
    subtitle: "把温柔调成慢速播放",
    tag: "治愈专题",
    intro:
      "忙碌了一天，不如看点让人安心的故事。本专题选取温暖细腻的家庭与成长作品，陪你度过一个柔软而安静的夜晚。",
    reason:
      "这些故事没有惊天动地的情节，却有最珍贵的烟火与陪伴。它们提醒我们：被爱着的日常，本身就是最好的礼物。",
    cover:
      "https://readdy.ai/api/search-image?query=heartwarming%20collection%20banner%20of%20a%20cozy%20sunlit%20living%20room%20with%20soft%20curtains%20plants%20and%20warm%20golden%20afternoon%20light%20gentle%20peaceful%20nostalgic%20atmosphere%20warm%20cream%20and%20amber%20tones%20cinematic%20wide%20composition%20no%20text&width=1280&height=720&seq=special-s3&orientation=landscape",
    mediaIds: ["mv3", "mv4", "tv13", "va19"],
  },
];